// React
import React, { useContext } from 'react';

// Styles
import styles from './Wrapper.module.scss';

// Components
import DetailForm from '../DetailForm/DetailForm';
import SalesChannelForm from '../SalesChannelForm/SalesChannelForm';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// This component
export default function Wrapper() {
  const {
		typeOfData
	} = useContext(DetailContext);

  // JSX
  return (
    <div className={styles.wrapper}>
      <div className={styles.main}>
        {typeOfData === 'sales-channel' ? <SalesChannelForm /> : <DetailForm />}
      </div>
    </div>
  );
}
